import React from 'react';

import { Grid, Text } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import FormFieldContentRow from './FormFieldContentRow';
import { SalesPortalOptionsFormValues } from '../SalesPortalOptionsDrawer';

interface IFormFieldContentProps {
  fields: {
    [field: string]: {
      isVisible: boolean;
      isRequired: boolean;
      visibleField: string;
      requiredField: string;
      disabled?: boolean;
    };
  }[];
  form: UseFormReturnType<SalesPortalOptionsFormValues>;
}

const FormFieldContent = ({ fields, form }: IFormFieldContentProps): JSX.Element => {
  return (
    <Grid columns={12}>
      <Grid.Col span={2} offset={1}>
        <Text fw='bold' fs='italic' fz='xs'>
          Visible Field
        </Text>
      </Grid.Col>
      <Grid.Col span={2}>
        <Text fw='bold' fs='italic' fz='xs'>
          Required Field
        </Text>
      </Grid.Col>
      <Grid.Col span={7}></Grid.Col>

      {fields.map(field => {
        const fieldKey = Object.keys(field)[0];
        const fieldValue = Object.values(field)[0];
        return (
          <FormFieldContentRow
            key={fieldKey}
            field={fieldKey}
            visibleField={fieldValue.visibleField}
            requiredField={fieldValue.requiredField}
            isVisible={fieldValue.isVisible}
            isRequired={fieldValue.isRequired}
            disabled={fieldValue.disabled}
            form={form}
          />
        );
      })}
    </Grid>
  );
};

export default FormFieldContent;
